import { z } from 'zod';

// Balance Sheet Multi Periods Data Item Interface
export interface BangCanDoiKeToanItem {
  id: string;
  ma_so: string;
  chi_tieu: string;
  systotal: number;
  [key: string]: any; // For dynamic period columns
}

// API Response Interface
export interface BangCanDoiKeToanResponse {
  results: BangCanDoiKeToanItem[];
  total: number;
}

// Hook Return Type Interface
export interface UseBangCanDoiKeToanReturn {
  data: BangCanDoiKeToanItem[];
  isLoading: boolean;
  error: Error | null;
  searchParams: any;
  fetchData: (searchParams: any) => Promise<void>;
  refreshData: () => Promise<void>;
}

// Form Field Options Types
export interface TimeTypeOption {
  label: string;
  value: number;
}

export interface ReportTemplateOption {
  label: string;
  value: string | number;
}

export interface AnalysisTemplateOption {
  label: string;
  value: string;
}

// Constants for form options
export const TIME_TYPE_OPTIONS: TimeTypeOption[] = [
  { label: 'Tháng', value: 1 },
  { label: 'Quý', value: 2 },
  { label: 'Nửa năm', value: 3 },
  { label: 'Năm', value: 4 }
];

export const REPORT_TEMPLATE_OPTIONS: ReportTemplateOption[] = [
  {
    label: 'Bảng cân đối kế toán - Thông tư 200',
    value: 'BCDKT01'
  }
];

export const CURRENCY_TEMPLATE_OPTIONS: ReportTemplateOption[] = [
  { label: 'Mẫu tiền chuẩn', value: 20 },
  { label: 'Mẫu tiền nt', value: 30 }
];

export const ANALYSIS_TEMPLATE_OPTIONS: AnalysisTemplateOption[] = [
  {
    label: 'Bảng cân đối kế toán theo đơn vị',
    value: 'balance_sheet_unit'
  }
];
